module.exports = __webpack_public_path__ + "img/inoffice_interview.cac5378c.svg";